<app-demo [datasource]="datasource" [context]="demoContext" [sources]="sources">
  <div actions>
    The Scroller is
    {{ (datasource.adapter.isLoading$ | async) ? 'loading' : 'relaxing' }},
    counter {{ loadingCounter() }}
    <br />
    Inner loop is
    {{ (datasource.adapter.loopPending$ | async) ? 'pending' : 'stopped' }},
    counter: {{ innerLoopCounter() }}
  </div>
  <div description>
    <p>
      The Scroller has internal process layer that might be called "inner loop",
      which is responsible for single fetch-clip-render chain. Inner loop can be
      empty and non-empty. Empty inner loop does nothing but check if the
      Scroller could relax. Non-empty inner loop corresponds to 1
      <em>Datasource.get</em> call (which is "fetch" subprocess) and following
      viewport updates: clipping old items, inserting new ones and render.
      <em>Adapter.loopPending</em> read-only scalar property and
      <em>Adapter.loopPending$</em> observable property lets us know if the
      "inner loop" is pending or not.
    </p>
    <p>
      The <em>isLoading</em> property, which we discussed earlier, majorizes
      <em>loopPending</em> property, and this demo shows how they correlate.
      Here we count the Scroller "loading" sessions and the Scroller "inner
      loops" within the <em>Adapter.isLoading$</em> and
      <em>Adapter.loopPending$</em> streams respectively, and expose counters as
      signals. After the
      Scroller is initialized and started relaxing, we see that there are 4
      inner loops done, while <em>isLoading</em> counter is 1. Practically it
      means that we have 3 <em>Datasource.get</em> calls and 1 more empty loop
      to ensure that the Scroller could relax. And these 4 inner loops are being
      packed into 1 "isLoading" session.
    </p>
    <p>So, we can distinguish 3 levels of pending:</p>
    <ul>
      <li>
        <em>Datasource.get</em> pending, which is fully manual, because the
        implementation of the <em>Datasource</em> is in our hands;
      </li>
      <li>
        <em>inner loop</em> pending, which is <em>loopPending</em> and which
        includes some internal Scroller's subprocesses (fetch, clip, render)
        that can take some time in addition to <em>Datasource.get</em> call
        (which is a part of "fetch" subprocess);
      </li>
      <li>
        <em>Workflow</em> pending, which is <em>isLoading</em>
        and which consists of one or more inner loops making up one continuous
        "loading" session.
      </li>
    </ul>
  </div>
</app-demo>
